import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { modules } from 'src/app/globals';

@Component({
  selector: 'app-offer-form',
  templateUrl: './offer-form.component.html',
  styleUrls: ['./offer-form.component.css']
})
export class OfferFormComponent implements OnInit {

  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  modules = modules;

  constructor(
    @Optional() @Inject('formGroup') public formGroup: FormGroup,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit(): void {
    if(!this.formGroup && this._controlContainer.control) this.formGroup = this._controlContainer.control as FormGroup;
  }

  get customerControl(): AbstractControl {
    return this.formGroup.controls['offercustomer'];
  }

}
